export default {
  name: 'smart-inspection',
  path: 'smart-inspection',
  component: () => import('@/views/container/Redirect.vue'),
  meta: { title: '智能巡检', redirect: true, hideSubMenu: true },
  children: [
    {
      name: 'smart-inspection-option',
      path: 'option',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '巡检计划管理', redirect: true, menuChildren: true },
      children: [
        {
          name: 'smart-inspection-option-list',
          path: 'list',
          component: () => import('@/views/smart-inspection/option/List.vue'),
          meta: { title: '巡检方案列表' }
        },
        {
          name: 'smart-inspection-option-add',
          path: 'add',
          component: () => import('@/views/smart-inspection/option/Add.vue'),
          meta: { title: '巡检方案新增' }
        },
        {
          name: 'smart-inspection-option-edit',
          path: 'edit',
          component: () => import('@/views/smart-inspection/option/Edit.vue'),
          meta: { title: '巡检方案编辑' }
        },
        {
          name: 'smart-inspection-option-detail',
          path: 'detail',
          component: () => import('@/views/smart-inspection/option/Detail.vue'),
          meta: { title: '巡检方案详情' }
        }
      ]
    },
    {
      name: 'smart-inspection-standard',
      path: 'standard',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '检查标准管理', redirect: true, menuChildren: true },
      children: [
        {
          name: 'smart-inspection-standard-list',
          path: 'list',
          component: () => import('@/views/smart-inspection/standard/List.vue'),
          meta: { title: '检查标准列表' }
        },
        {
          name: 'smart-inspection-standard-add',
          path: 'add',
          component: () => import('@/views/smart-inspection/standard/Add.vue'),
          meta: { title: '检查标准新增' }
        },
        {
          name: 'smart-inspection-standard-edit',
          path: 'edit',
          component: () => import('@/views/smart-inspection/standard/Edit.vue'),
          meta: { title: '检查标准编辑' }
        },
        {
          name: 'smart-inspection-standard-detail',
          path: 'detail',
          component: () => import('@/views/smart-inspection/standard/Detail.vue'),
          meta: { title: '检查标准详情' }
        }
      ]
    },
    {
      name: 'smart-inspection-records-manage',
      path: 'records-manage',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '巡检记录管理', redirect: true, menuChildren: true },
      children: [
        {
          name: 'recored-list-page',
          path: '',
          component: () => import('@/views/smart-inspection/records/List.vue'),
          meta: { title: '巡检记录列表' }
        },
        {
          name: 'smart-inspection-records-detail',
          path: 'detail',
          component: () => import('@/views/smart-inspection/records/Detail.vue'),
          meta: { title: '巡检记录详情' }
        },
        {
          name: 'smart-inspection-records-group',
          path: 'group-detail',
          component: () => import('@/views/smart-inspection/records/GroupDetail.vue'),
          meta: { title: '巡检记录详情' }
        },
        {
          name: 'smart-inspection-records-more',
          path: 'more',
          component: () => import('@/views/smart-inspection/records/More.vue'),
          meta: { title: '更多历史方案记录' }
        }
      ]
    },
    {
      name: 'smart-inspection-point',
      path: 'point',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '巡检点管理', redirect: true, menuChildren: true },
      children: [
        {
          name: 'smart-inspection-point-list',
          path: 'list',
          component: () => import('@/views/smart-inspection/point/Point.vue'),
          meta: { title: '巡检点管理' }
        }
      ]
    }

    // {
    //   name: 'smart-inspection-records',
    //   path: 'records',
    //   component: () => import('@/views/container/Redirect.vue'),
    //   meta: { title: '巡检记录', redirect: true, menuChildren: true, },
    //   children: [
 
    //     {
    //       name: 'smart-inspection-records-detail',
    //       path: 'detail',
    //       component: () => import('@/views/smart-inspection/records/Detail.vue'),
    //       meta: { title: '巡检记录详情' },
    //     },
    //     {
    //       name: 'smart-inspection-records-group',
    //       path: 'group-detail',
    //       component: () => import('@/views/smart-inspection/records/GroupDetail.vue'),
    //       meta: { title: '组合记录详情' },
    //     }
    //   ]
    // }
  ]
}
